const INTERVAL_LABEL = { monthly: "month", yearly: "year", quarterly: "quarter", lifetime: "one-time" };

export const intervalLabel = (i) => INTERVAL_LABEL[i] || i || "month";

// The API returns price as a string ("999.00") and currency as "" - INR.
export function formatPrice(price) {
  const n = Number(price);
  if (!Number.isFinite(n)) return "-";
  return `₹${n.toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
}

// Free either by flag or by a zero price ("0.00").
export const isFreePlan = (plan) => Boolean(plan?.isFree) || Number(plan?.price) === 0;

const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);

// Human-readable bullet list from a plan's `limits`.
export function planFeatures(limits = {}) {
  const out = [];
  const count = (n, what) => (n == null ? null : n < 0 || n >= 999999 ? `Unlimited ${what}` : `${n} ${what}`);
  out.push(count(limits.maxClients, "clients"));
  out.push(count(limits.maxBusinesses, "businesses"));
  if (limits.allowedChannels?.length) out.push(`Channels: ${limits.allowedChannels.map(cap).join(", ")}`);
  if (limits.allowedSoftwares?.length)
    out.push(`Software: ${limits.allowedSoftwares.map((s) => s.toUpperCase()).join(", ")}`);
  if (limits.allowWhitelabel) out.push("White-label included");
  return out.filter(Boolean);
}
